import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import treemap from "highcharts/modules/treemap";

addMore(Highcharts);
treemap(Highcharts);

@Component({
  selector: "app-graph-widget",
  templateUrl: "./graph-widget.component.html",
  styleUrls: ["./graph-widget.component.scss"]
})
export class GraphWidgetComponent implements OnInit {
  @Input() chartoptions: []; // Sample Input : [{chart : HSET.chart1, width: 5 }]  -- ALlows for multiple charts with desired widths
  @Input() heading = ""; // Sample Input : "Reasons For Failure"
  @Input() dropdownItems = []; // List for dropdown elements, Eg: ['All', 'Val1', 'Val2']
  @Output() dropdownChange = new EventEmitter(); // event to fire on drop down select
  @Input() tabItems = []; // Sample Input : ['tab1', 'tab2', 'tab3']
  @Output() tabChange = new EventEmitter(); // event to fire on tab select
  activeTab = "";
  highcharts: typeof Highcharts = Highcharts;
  selectedOption = [];

  constructor() {}

  onTabChange(tabClicked) {
    console.log(tabClicked);
    this.activeTab = tabClicked;
    this.tabChange.emit({ event: tabClicked });
  }

  ngOnInit() {
    this.selectedOption[0] = this.dropdownItems[0];
    this.activeTab = this.tabItems.length ? this.tabItems[0] : "";
  }
}
